import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {InitializationAndConfigurationService} from '../services/configuration/initializationAndConfiguration.service';
import {DatePipe, NgClass, NgForOf, NgIf} from '@angular/common';
import {ApplicationService} from '../services/application.service';
import {Router} from '@angular/router';
import {ToDoItemService} from '../services/toDoItem.service';

@Component({
    selector: 'to-do-list',
    templateUrl: 'toDoList.component.html',
    styleUrls: ['toDoList.component.scss'],
    standalone: true,
    imports: [
        NgForOf,
        NgIf,
        NgClass,
        DatePipe
    ]
})
export class ToDoListComponent implements OnInit {
    @Output() itemSelected = new EventEmitter<void>();
    public toDoCategoryConfiguration: any;
    public activeCategory: any;

    constructor(public applicationService: ApplicationService,
                public initializationAndConfigurationService: InitializationAndConfigurationService,
                public toDoItemService: ToDoItemService,
                public router: Router) {}

    ngOnInit() {
        this.toDoCategoryConfiguration = this.initializationAndConfigurationService.getToDoCategoryConfiguration();
    }

    switchCategoryDisplay(categoryType) {
        this.toDoCategoryConfiguration.forEach((category) => {
            if (category.toDoType === categoryType) {
                this.activeCategory = category;
            }
        });
    }

    displayIcon(category) {
        if (this.initializationAndConfigurationService.getApplicationConfiguration() == null) {
            // error in getting the limit
        }

        return category.originalCount >= (this.initializationAndConfigurationService.getApplicationConfiguration().inboxItemsLimit * category.pageCnt);
    }

    showMore(categoryType) {
        this.toDoItemService.refreshCategory(categoryType);
    }

    isActiveCategory(categoryType) {
        if (this.activeCategory === categoryType) {
            return 'active';
        } else {
            return '';
        }
    }

    getBadgeClass(severityScore, count) {
        if (count > 0) {
            switch (severityScore) {
                case 0 :
                    return 'text-bg-success';
                case 1 :
                    return 'text-bg-warning';
                case 2 :
                    return 'text-bg-danger';
                default:
                    return 'text-bg-success';
            }
        } else {
            return 'text-bg-success';
        }
    }

    selectItem(selectedItem) {
        this.router.navigate([this.activeCategory.forwardTo(selectedItem)]);
        this.itemSelected.emit();
    }
}
